module.exports = __webpack_public_path__ + "img/nav-design-withdiamonds.b1f8e74.jpg";